import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Injectable } from '@angular/core';
import { MzBaseModal, MzModalComponent } from 'ngx-materialize';
import { esquemas } from 'src/app/_models/formularios/esquemas.model';
import { ZeroService } from 'src/app/_services/zero/zero.service';


@Component({
  selector: 'app-modaledit-esqu',
  templateUrl: './modaledit-esqu.component.html',

})
export class ModaleditEsquComponent extends MzBaseModal {
  public esquema: esquemas;
  //Variables que provienen de los campos
  @ViewChild('IDESQU') IDESQU: ElementRef;
  @ViewChild('CLVESQU') CLVESQU: ElementRef;
  @ViewChild('DSCESQU') DSCESQU: ElementRef;
  @ViewChild('WarningEsqu') WarningEsqu: MzModalComponent;
  @ViewChild('ErrorEditEsqu') ErrorEditProc: MzModalComponent;
  // datos de entrada por el servicio de modal
  @Input() public idEsquemaPK: number;
  @Input() public descripcion: string;
  @Input() public clave: number;
  // Emitter para envío de parámetros
  @Output() updateEsqu: EventEmitter<esquemas>;
  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%',
  };

  constructor(private zeroService: ZeroService) {
    super();
    this.updateEsqu = new EventEmitter();
    this.esquema = new esquemas();
  }

  ngOnInit() {
    this.esquema.idAnt = this.idEsquemaPK;
  }
  cancelar() {
    this.modalComponent.closeModal();
    this.WarningEsqu.closeModal();
  }
  // Aceptando el modal 
  public closeModal() {
    this.esquema.idEsquemaPK = this.IDESQU.nativeElement.value;
    this.esquema.descripcion = this.DSCESQU.nativeElement.value;
    this.esquema.clave = this.CLVESQU.nativeElement.value;
    this.esquema.descripcion = this.esquema.descripcion.trim();
    if (this.esquema.idEsquemaPK == null ||
      this.esquema.descripcion == null ||
      this.esquema.descripcion.trim().length == 0 ||
      this.esquema.clave.toString().trim().length == 0) {

      this.ErrorEditProc.openModal();
    } else {
      if (this.esquema.idAnt != this.esquema.idEsquemaPK) {
        this.WarningEsqu.openModal();
      } else {
        this.updateEsqu.emit(this.esquema);
        this.modalComponent.closeModal();
      }
    }
  }
  public closeModalwarning() {
    this.esquema.idEsquemaPK = this.IDESQU.nativeElement.value;
    this.esquema.descripcion = this.DSCESQU.nativeElement.value;
    this.esquema.clave = this.CLVESQU.nativeElement.value;
    this.esquema.descripcion = this.esquema.descripcion.trim();
    this.updateEsqu.emit(this.esquema);
    this.cancelar();
  }
}
